import { defineMessages } from 'react-intl'

export const locale = defineMessages({
  getToKnowUs: {
    id: 'footer.get-to-know-us',
    defaultMessage: 'Get to know us',
  },
  about: {
    id: 'footer.about',
    defaultMessage: 'About',
  },
  jobs: {
    id: 'footer.jobs',
    defaultMessage: 'Jobs',
  },
  blog: {
    id: 'footer.blog',
    defaultMessage: 'Blog',
  },
  getHelp: {
    id: 'footer.get-help',
    defaultMessage: 'Get help',
  },
  contactUs: {
    id: 'footer.contact-us',
    defaultMessage: 'Contact us',
  },
  findEvents: {
    id: 'footer.find-events',
    defaultMessage: 'Find events',
  },
  topEvents: {
    id: 'footer.top-events',
    defaultMessage: 'Top events',
  },
  hostEvents: {
    id: 'footer.host-events',
    defaultMessage: 'Host events',
  },
  becomeHost: {
    id: 'footer.become-a-host',
    defaultMessage: 'Become a host',
  },
  tour: {
    id: 'footer.tour',
    defaultMessage: 'Tour',
  },
  embeddableWidgets: {
    id: 'footer.embeddable-widgets',
    defaultMessage: 'Embeddable widgets',
  },
  customers: {
    id: 'footer.customers',
    defaultMessage: 'Customers',
  },
  pricing: {
    id: 'footer.pricing',
    defaultMessage: 'Pricing',
  },
  getOnsiteApp: {
    id: 'footer.get-the-onsite-app',
    defaultMessage: 'Get the onsite app',
  },
  developers: {
    id: 'footer.developers',
    defaultMessage: 'Developers',
  },
  termsAndConditions: {
    id: 'footer.terms-and-conditions',
    defaultMessage: 'Terms and Conditions',
  },
  termsOfUse: {
    id: 'footer.terms-of-use',
    defaultMessage: 'Terms of Use',
  },
  privacyPolicy: {
    id: 'footer.privacy-policy',
    defaultMessage: 'Privacy policy',
  },
  cookiePolicy: {
    id: 'footer.cookie-policy',
    defaultMessage: 'Cookie policy',
  },
  manageCookies: {
    id: 'footer.manage-cookies',
    defaultMessage: 'Manage cookies',
  },
  doNotSellMyInformation: {
    id: 'footer.do-not-sell-my-information',
    defaultMessage: 'Do Not Sell Or Share My Personal Information',
  },
  linkToHomePage: {
    id: 'footer.linkToHomePage',
    defaultMessage: 'link to universe homepage',
  },
  linkToTwitter: {
    id: 'footer.linkToTwitter',
    defaultMessage: 'link to universe page on twitter',
  },
  linkToFacebook: {
    id: 'footer.linkToFacebook',
    defaultMessage: 'link to universe page on facebook',
  },
  linkToInstagram: {
    id: 'footer.linkToInstagram',
    defaultMessage: 'link to universe page on instagram',
  },
  linkToTermsAndConditions: {
    id: 'footer.linkToTermsAndConditions',
    defaultMessage: 'link to terms and conditions',
  },
  linkToTermsOfUse: {
    id: 'footer.linkToTermsOfUse',
    defaultMessage: 'link to terms of use',
  },
  linkToPrivacyPolicy: {
    id: 'footer.linkToPrivacyPolicy',
    defaultMessage: 'link to privacy policy',
  },
  linkToDoNotSellMyInformation: {
    id: 'footer.linkToDoNotSellMyInformation',
    defaultMessage: 'link to do not sell my information',
  },
  linkToCookiePolicy: {
    id: 'footer.linkToCookiePolicy',
    defaultMessage: 'link to cookie policy',
  },
  linkToAbout: {
    id: 'footer.linkToAbout',
    defaultMessage: 'link to about',
  },
  linkToJobs: {
    id: 'footer.linkToJobs',
    defaultMessage: 'link to jobs',
  },
  linkToGetHelp: {
    id: 'footer.linkToGetHelp',
    defaultMessage: 'link to get help',
  },
  linkToBlog: {
    id: 'footer.linkToBlog',
    defaultMessage: 'link to blog',
  },
  linkToContactUs: {
    id: 'footer.linkToContactUs',
    defaultMessage: 'link to contact us',
  },
  linkToFindEvents: {
    id: 'footer.linkToFindEvents',
    defaultMessage: 'link to find events',
  },
  linkToTopEvents: {
    id: 'footer.linkToTopEvents',
    defaultMessage: 'link to top events',
  },
  linkToBecomeHost: {
    id: 'footer.linkToBecomeHost',
    defaultMessage: 'link to become a host',
  },
  linkToTour: {
    id: 'footer.linkToTour',
    defaultMessage: 'link to tour',
  },
  linkToEmbeddableWidgets: {
    id: 'footer.linkToEmbeddableWidgets',
    defaultMessage: 'link to embeddable widgets',
  },
  linkToCustomers: {
    id: 'footer.linkToCustomers',
    defaultMessage: 'link to customers',
  },
  linkToPricing: {
    id: 'footer.linkToPricing',
    defaultMessage: 'link to pricing',
  },
  linkToGetOnsiteApp: {
    id: 'footer.linkToGetOnsiteApp',
    defaultMessage: 'link to get the onsite app',
  },
  linkToDevelopers: {
    id: 'footer.linkToDevelopers',
    defaultMessage: 'link to developers',
  },
  selectLanguage: {
    id: 'footer.select-language',
    defaultMessage: 'Select Language',
  },
  language: {
    id: 'footer.language',
    defaultMessage: 'Language',
  },
})
